<div class="input-container">
    <input ngxDaterangepickerMd [value]="value" (change)="onValueChange($event)" [placeholder]="placeholder"
        class="form-control form-control-lg" [autoApply]="true"
        [locale]="{ applyLabel: 'Apply', cancelLabel: 'Cancel', format: 'DD-MM-YYYY' }" [singleDatePicker]="true"
        readonly [formControl]="control" />

    <!-- <material-timepicker color="primary" label="" appearance="fill"
        [userTime]="{ hour: 8, minute: 0, format: 12, meriden: 'PM'  }" (change)="onTimeChange($event)"
        revertLabel="{{ 'PRODUCTS.BTN.RESET' | translate }}" submitLabel="{{ 'MODULES.BTN.CREATE_BTN' | translate }}"
        [disabled]="false" [readonly]="false"></material-timepicker> -->

    <span class="clear-btn" (click)="resetPicker()" *ngIf="value">×</span>
</div>